// @flow

import React from 'react'
import { createComponent } from 'react-fela'
import { Box } from 'kilvin'

const pulse = () => ({
	'0%': { opacity: 0.5 },
	'40%': { opacity: 1 },
	'100%': { opacity: 0.5 },
})

export const __loading = ({ theme, customColor }) => ({
	fontSize: '16px',
	margin: '0 auto',
	color: customColor || theme.colorWhite,
	'& span': {
		animationName: pulse(),
		animationDuration: '1.4s',
		animationIterationCount: 'infinite',
		animationFillMode: 'both',
	},

	'& span:nth-child(2)': {
		animationDelay: '0.2s',
	},

	'& span:nth-child(3)': {
		animationDelay: '0.4s',
	},
})

const __loadingIcon = ({ theme }) => ({
	fontSize: theme.fontSize.xl,
	paddingLeft: 3,
	paddingRight: 3,
})

const LoadingIcon = createComponent(__loadingIcon, 'span')

const LoadingWrapper = createComponent(__loading)

const SubLoader = ({ customColor, loaderText = '' }) => (
	<Box center>
		<LoadingWrapper customColor={customColor}>
			<LoadingIcon>•</LoadingIcon>
			<LoadingIcon>•</LoadingIcon>
			<LoadingIcon>•</LoadingIcon>
			{loaderText}
		</LoadingWrapper>
	</Box>
)

export default SubLoader
